import { axiosApi } from '../globals';

export namespace quality {
  export const get = (generatorId: string) => {
    return axiosApi.run('get', `/v2/quality/${generatorId}`);
  };

  export const add = (quality: IQuality) => {
    return axiosApi.run('post', '/v2/quality', quality);
  };

  export const getAll = () => {
    return axiosApi.run('get', '/v2/quality');
  };

  export const patch = (qualityId: string, change: Json) => {
    return axiosApi.run('patch', `/v2/quality/${qualityId}`, change);
  };
}
